import { connectAndForwardRef } from 'util/redux'
import { selectAccountChatRoomId } from 'selectors/app/selectAccountPreferences'
import ShadowBodyView from './view'

const select = state => ({
  accountChatRoomId: selectAccountChatRoomId(state),
})

export default connectAndForwardRef(select)(ShadowBodyView)
